import axiosClient from "../axios/axiosClient";

export function getAwards() {
  return axiosClient.get("/awards");
}

export function getAward(awardId) {
  return axiosClient.get(`/awards/${awardId}`);
}

export function createAward(data) {
  return axiosClient.post("/awards", data);
}

export const updateAward = (awardId, data) => {
  return axiosClient.put(`/awards/${awardId}`, data);
};

export function deleteAward(awardId) {
  return axiosClient.delete(`/awards/${awardId}`);
}
